import { Vector3 } from "three";

export function getVectorBetween(from: Vector3, to: Vector3): Vector3 {
    const between = new Vector3().add(to).sub(from);
    return between;
}

interface ILocation {
    locationX: number;
    locationY: number;
    locationZ: number;
}

export function vector3ToLocation(vector3: Vector3): ILocation {
    const { x: locationX, y: locationY, z: locationZ } = vector3;
    return { locationX, locationY, locationZ };
}

export function locationToVector3(location: ILocation): Vector3 {
    const { locationX, locationY, locationZ } = location;
    return new Vector3(locationX, locationY, locationZ);
}
